module.exports = __webpack_public_path__ + "media/Coupon.acb55ce7.mp3";